"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Table_1 = __importDefault(require("@material-ui/core/Table"));
const TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const react_router_dom_1 = require("react-router-dom");
const TextCopyButton_1 = require("./TextCopyButton");
const TableCell = styles_1.withStyles(theme => ({
    root: {
        cursor: 'pointer',
    },
    head: Object.assign(Object.assign({ backgroundColor: theme.palette.background.default }, theme.typography.body2), { fontSize: '16px', fontWeight: 'bold', textAlign: 'center', '&:hover': {
            backgroundColor: theme.palette.grey[200],
        } }),
    body: {
        fontSize: '16px',
    },
}))(TableCell_1.default);
function createCells(field, doc, 
// eslint-disable-next-line no-unused-vars
onMessageSent) {
    const text = field.toFormat(doc);
    const button = field.copyable ? (react_1.default.createElement(TableCell, { style: { textAlign: 'right', padding: '0px 0px 0px 10px' } },
        react_1.default.createElement(TextCopyButton_1.TextCopyButton, { isSmall: true, text: text, onMessageSent: onMessageSent }))) : null;
    let content;
    if (field.toUrl === undefined) {
        content = text;
    }
    else {
        const url = field.toUrl(doc);
        if (url == null) {
            content = text;
        }
        else {
            content = (react_1.default.createElement(react_router_dom_1.Link, { to: url, onMouseUp: e => e.stopPropagation(), target: "_blank" }, text));
        }
    }
    return (react_1.default.createElement(react_1.Fragment, { key: field.label },
        button,
        react_1.default.createElement(TableCell, { key: field.label, style: {
                textAlign: field.textAlign,
                padding: '0px 10px',
            } }, content)));
}
function DataTableView({ header, fields, data, createMouseUpHandler = () => () => { }, selectFilterPath = () => { }, onMessageSent, }) {
    return (react_1.default.createElement(Table_1.default, { style: { width: 'unset' } },
        react_1.default.createElement(TableHead_1.default, null,
            react_1.default.createElement(TableRow_1.default, { key: "header" }, fields.map((field) => (react_1.default.createElement(TableCell, { key: field.label, onClick: () => selectFilterPath(field), colSpan: field.copyable ? 2 : 1, style: {
                    padding: "10px",
                    width: field.width,
                    textAlign: field.textAlign,
                } }, field.label))))),
        react_1.default.createElement(TableBody_1.default, null, data.map((doc, index) => (react_1.default.createElement(TableRow_1.default, { hover: true, style: header.getStyle === undefined ? null : header.getStyle(doc), key: header.getUniqueId(doc), "data-testid": `DataRow-${header.getUniqueId(doc)}`, onClick: e => createMouseUpHandler(e)(index) }, fields.map(f => (createCells(f, doc, onMessageSent)))))))));
}
exports.default = DataTableView;
